export default "__VITE_ASSET__DAcgSRH2__"